/** Editable request copy only. No recipients, dates, ownership facts or delivery are inferred. */
export function propertyScheduleRequest(buildingName:string){
 const name=buildingName.replace(/[\r\n\u0000-\u001f]+/g,' ').trim().slice(0,180);
 return {subject:`Property and leaseholder schedule — ${name}`,body:`Please provide the current property and leaseholder schedule for ${name}, preferably as the existing spreadsheet, document or report.

Please include, where recorded:
- Actual flat/unit references and property addresses, including commercial units.
- Named leaseholders/owners and recorded ownership interests or roles, with their supporting source.
- Correspondence addresses, email addresses and telephone numbers.
- Resident/occupier details and effective dates where available.
- The schedule date, residential/commercial totals and any known gaps, duplicates or disputed information.

Please retain the original column headings and identify information that is unknown or requires verification. Use the agreed secure handover channel for personal information.

Thank you.`};
}
